import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { MBE_NOTIFICATION_LETTERS_FORM_NAME } from 'Common/FormEnum';
import React, { Component, Fragment } from 'react';
import moment from 'moment';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Grid } from 'semantic-ui-react';
import { MBEGrid } from './MBEGrid';
import { TitledCard } from 'Components/';
import { DatePickerField, SelectField } from 'Common/SemanticWrapper';
import { MBENotificationLettersFieldEnum as Fields } from 'Common/FieldEnum';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { isPreferenceDisabled } from 'Common/Security/SecurityHelpers';
import { PreferencesEnum as PrefEnum } from 'Common/Security/PreferencesEnum';
import {
  YesNoOptions,
  makeButtonGroupOptionsFromEnum,
} from 'Common/FormHelper';
import { MBENotificationLetterTypes } from 'Common/Constants/Enumeration/MBENotificationLetterTypes';

class MBENotificationLettersFormContainer extends Component {
  componentDidMount() {
    this.props.onEmailSubmit(this.props.submit);
  }

  PrintTypeOptions = [
    { value: 0, label: 'Print' },
    { value: 1, label: 'Email' },
  ];

  SortByOptions = [
    { value: 0, key: 0, text: 'Parent Last Name, Parent First Name' },
    {
      value: 1,
      key: 1,
      text: 'Zip Code, Parent Last Name, Parent First Name',
    },
    {
      value: 2,
      key: 2,
      text: 'Student Site ID, Teacher, Student Last Name, Student First Name',
    },
  ];

  ParentAddressOptions = [
    { value: 0, label: 'Student Account' },
    { value: 1, label: 'Previous Meal Application' },
  ];

  render() {
    const { letterType } = this.props;

    return (
      <Fragment>
        <TitledCard title="Options">
          <Grid>
            <Grid.Row>
              <Grid.Column width={4}>
                <Field
                  label={'Date of Letter:'}
                  name={Fields.LetterDate}
                  component={DatePickerField}
                  type="text"
                  openToDate={moment()}
                />
              </Grid.Column>
              <Grid.Column width={8}>
                <ReduxFormButtonGroup
                  formName={MBE_NOTIFICATION_LETTERS_FORM_NAME}
                  fieldName={Fields.LetterType}
                  name={Fields.LetterType}
                  options={makeButtonGroupOptionsFromEnum(
                    MBENotificationLetterTypes
                  )}
                  label={'Letter Type:'}
                />
              </Grid.Column>
              <Grid.Column className="input-group--btn-group" width={4}>
                <ReduxFormButtonGroup
                  formName={MBE_NOTIFICATION_LETTERS_FORM_NAME}
                  fieldName={Fields.ShowSiteName}
                  name={Fields.ShowSiteName}
                  options={YesNoOptions}
                  label={'Show Site Name:'}
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={4}>
                <ReduxFormButtonGroup
                  label={'Action:'}
                  options={this.PrintTypeOptions}
                  formName={MBE_NOTIFICATION_LETTERS_FORM_NAME}
                  value={false}
                  fieldName={Fields.PrintType}
                  disabled={isPreferenceDisabled(
                    PrefEnum.MBEEmailLetters,
                    this.props.security.preferences
                  )}
                />
              </Grid.Column>
              <Grid.Column width={12}>
                <Field
                  name={Fields.SortByType}
                  component={SelectField}
                  type="text"
                  label="Sort By:"
                  options={this.SortByOptions}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>

        {letterType === MBENotificationLetterTypes.MBENotification && (
          <TitledCard title="MBE Notification Options">
            <Grid>
              <Grid.Row>
                <Grid.Column>
                  <ReduxFormButtonGroup
                    label={'Get Parent Address from:'}
                    options={this.ParentAddressOptions}
                    formName={MBE_NOTIFICATION_LETTERS_FORM_NAME}
                    value={0}
                    fieldName={Fields.AddressFromType}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>

            <div>
              <label>Calendar:</label>
              <MBEGrid data={this.props.calendars} />
            </div>
          </TitledCard>
        )}
      </Fragment>
    );
  }
}

const validate = values => {
  var errors = [];

  if (!moment(values[Fields.LetterDate]).isValid()) {
    errors[Fields.LetterDate] = 'Letter date is required.';
  }
  return errors;
};

const selector = formValueSelector(MBE_NOTIFICATION_LETTERS_FORM_NAME);
const mapStateToProps = state => {
  const { report } = state.MBENotificationLettersState;

  return {
    calendars: report.calendars,
    security: state.SecurityState,
    letterType: selector(state, Fields.LetterType),
  };
};

const MBENotificationLettersForm = reduxForm({
  form: MBE_NOTIFICATION_LETTERS_FORM_NAME,
  validate,
})(
  withRouter(connect(mapStateToProps, {})(MBENotificationLettersFormContainer))
);

export { MBENotificationLettersForm };



// WEBPACK FOOTER //
// ./src/pages/mbenotification/components/MBENotificationLettersForm.js